import { TableAdministradora } from "./Components/table/TableAdministradora";

export const PageAdministradoras = () => {
  return <TableAdministradora />;
};
